export class AudioPageController {
    constructor($scope, contentUtilService) {
        'ngInject';

        contentUtilService.markAndTrustContentAsHtml($scope.content, 'introduction');
        contentUtilService.markAndTrustContentAsHtml($scope.content, 'body');
        contentUtilService.markAndTrustContentAsHtml($scope.content, 'keyPoints');
        contentUtilService.markAndTrustContentAsHtml($scope.content, 'transcript');
    }
}